import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography, Box } from '@mui/material';
import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;
const explain1= 'Helsinki, Espoo, Vantaa Ilmainen Toimitus'
const explain2= 'Olemme pahoillamme, mutta emme voi tarjota toimituspalvelua yli 300 km matkalta.'
let distance=0

const AddressDialog = ({ open, onClose, onSubmit }) => {
  const [address, setAddress] = useState({
    street: '',
    city: '',
    postalCode: '',
    phone: ''
  });
  const [deliveryFee, setDeliveryFee] = useState(0);
  const [postalCodeError, setPostalCodeError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [explain, setExplain] = useState('Deneme');
  
 

  useEffect(() => {
    if (address.postalCode) {
      fetchDeliveryFee();
    }
  }, [address.postalCode]);

  const fetchDeliveryFee = () => {
    if (address.postalCode < '03000'){
      setDeliveryFee(0);
      setPostalCodeError(false);
      setExplain(explain1)
    }else{
    axios.get(apiUrl +`/distance/${address.postalCode}`)
      .then(response => {
        distance = roundNumber(parseFloat(response.data[0].replace(' km', '')));
        setDeliveryFee(distance);
        setPostalCodeError(false);
        if (distance > 300){
          setExplain(explain2) 
        }
      })
      .catch(error => {
        console.error('Error fetching delivery fee:', error);
        setPostalCodeError(true);
      });

    }
  };
  
  const handleAddressChange = (e) => {
    
    const { name, value } = e.target;
    setAddress({
      ...address,
      [name]: value
    });

    if (name === 'phone') {
      const phonePattern = /^[0-9]{10}$/; // 10 haneli telefon numarası
      setPhoneError(!phonePattern.test(value));
    }
  };

  const handleSubmit = () => {
    onSubmit(address,deliveryFee);
  };

  const handleCancel = () => {
    setAddress({
      street: '',
      city: '',
      postalCode: '',
      phone: ''
    });
    setDeliveryFee(0);
    setPostalCodeError(false);
    setPhoneError(false);
    onClose();
    setExplain('')
  };

  const isFormValid = () => {
    return address.street && address.city && address.postalCode && address.phone && !phoneError && !postalCodeError && deliveryFee < 301;
  };

  const roundNumber = (num) => {
    const remainder = num % 10;
  
    if (remainder < 5) {
      return num - remainder + (remainder >= 2.5 ? 5 : 0);
    } else {
      return num - remainder + 10;
    }
  };
  
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Osoite Tiedot</DialogTitle>
      <DialogContent>
        <TextField
          name="street"
          label="Katuosoite"
          fullWidth
          margin="normal"
          value={address.street}
          onChange={handleAddressChange}
        />
        <TextField
          name="city"
          label="Kaupunki"
          fullWidth
          margin="normal"
          value={address.city}
          onChange={handleAddressChange}
        />
        <TextField
          name="postalCode"
          label="Postinumero"
          fullWidth
          margin="normal"
          value={address.postalCode}
          onChange={handleAddressChange}
          error={postalCodeError}
          helperText={postalCodeError ? "Geçersiz posta kodu" : ""}
        />
        <TextField
          name="phone"
          label="Puhelin"
          fullWidth
          margin="normal"
          value={address.phone}
          onChange={handleAddressChange}
          error={phoneError}
          helperText={phoneError ? "Geçersiz telefon numarası" : ""}
        />
        <Box mt={2} mb={2}>
          <Typography variant="h6" display={deliveryFee >300 ? 'none':'block'}>Toimitus: {deliveryFee} €</Typography>
          {postalCodeError && <Button onClick={() => fetchDeliveryFee()} color='error' variant='text'>Laske Toimitus</Button>}
          <Typography variant='body2'>{explain}</Typography>
        </Box>
      </DialogContent>
      <DialogActions >
        <Box    sx={{ display: 'flex',  justifyContent: 'space-between' , width:'100%' }}>
        <Button onClick={handleCancel} color='inherit' variant="contained">Cancel</Button>
        <Button onClick={handleSubmit} color='success' variant="contained" disabled={!isFormValid() || postalCodeError}>Tallenna</Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default AddressDialog;